import { ComponentPropsWithoutRef, ComponentRef, FC, ReactNode, Ref } from 'react';
import classNames from 'classnames';
import { Dialog as RadixDialog } from 'radix-ui';

import styles from './ModalHeader.module.css';

export type ModalHeaderProps = {
  children: ReactNode;
  className?: string;
  ref?: Ref<ComponentRef<typeof RadixDialog.Title>>;
} & Omit<ComponentPropsWithoutRef<typeof RadixDialog.Title>, 'className'>;

/** Заголовок модалки — рендерится как Dialog.Title, даёт aria-labelledby автоматически. */
const ModalHeader: FC<ModalHeaderProps> = ({ children, className, ref, ...rest }) => (
  <RadixDialog.Title
    ref={ref}
    {...rest}
    className={classNames(styles.header, className)}>
    {children}
  </RadixDialog.Title>
);

export default ModalHeader;
